import * as api from "~/api/resource";
import _ from "lodash";
import {mapActions, mapGetters} from "vuex";
import {fetchList, getModxList, getModxProcessor} from "../api/resource";
import {Notify} from "quasar";

export default {
    props: {},
    data() {
        return {
            formDada: {},
            loggedUser: null,
            silentMessages: false,
            last_booking_warning: null
        };
    },
    computed: {
        ...mapGetters({
            formConfiguration: "configuration/getBookingForm",
        }),
        ScheduleTrip() {
            return this.$store.state.ScheduleTrip;
        },
        priceContext() {
            if (this.ScheduleTrip)
                return {
                    tripServiseId: this.ScheduleTrip.serviseId,
                    tripid: this.formDada.tripid,
                    repid: this.formDada.repid,
                    coid: this.formDada.tourCoId,
                    prices_for: 'Excursions',
                    routeseq: this.formDada.ppid,
                    children: this.formDada.children,
                    adults: this.formDada.adults,
                    distributor: this.formDada.distributor,
                }
            return null
        }
    },
    watch: {
        'formDada.tourCoId': {
            async handler(v, vo) {
                if (v == vo) return;
                if (!this.priceContext) return
                await this.setPrices()
            },
            // immediate: true,
        },
        'formDada.ppid': {
            async handler(v, vo) {
                if (v == vo) return;
                if (!this.priceContext) return
                await this.setPrices()
            },
            // immediate: true,
        },
        'formDada.children': {
            async handler(v, vo) {
                await this.validateBooking()
                if (!this.priceContext) return
                if (v == vo) return;
                await this.setPrices()
            },
            // immediate: true,
        },
        'formDada.adults': {
            async handler(v, vo) {
                await this.validateBooking()
                if (!this.priceContext) return
                if (v == vo) return;
                await this.setPrices()
            },
            // immediate: true,
        },
        // $route: {
        //     async handler(to, from) {
        //         return;
        //     },
        //     immediate: true,
        // },
        // "ScheduleTrip.TripService.price1": {
        //     async handler(price, oldPrice) {
        //         if (
        //             !price &&
        //             !oldPrice &&
        //             this.ScheduleTrip &&
        //             this.ScheduleTrip.TripService
        //         ) {
        //             this.formDada.tickePriceAdult = this.ScheduleTrip.TripService.price1;
        //         }
        //     },
        //
        //     immediate: true,
        // },
        "$route.params.bookingid": {
            async handler(bkid, oldval) {
                _log_("get $route.params.bookingid ", bkid, oldval);
                if (bkid && bkid != oldval) {
                    await this.loadBooking(bkid);
                    if (!bkid) this.$emit("done", null);
                }
            },
            immediate: true,
        },
    },
    methods: {

        async validateBooking() {
            this.last_booking_warning = null;
            const validate = await api.getModxProcessor('vue_booking/bookingsvalidator', this.formDada)
            if (validate && validate.state != 'ok') {
                if (!this.silentMessages)
                    this.$message({message: validate.message, type: "warning"})
                this.last_booking_warning = validate
            }
        },
        async setPrices() {
            const priceCalc = await api.getModxList('pricerules/calcprices', this.priceContext)

            if (priceCalc && priceCalc.pricerule) {
                const prices = priceCalc.pricerule
                if (!this.formDada.id ||
                    !this.formDada.tickePriceAdult ||
                    this.formDada.tickePriceAdult == 0
                )
                    this.$set(
                        this.formDada,
                        "tickePriceAdult",
                        prices.adultPrice
                    );
                if (!this.formDada.id || !this.formDada.ticketPriceKid || this.formDada.ticketPriceKid == 0)
                    this.$set(
                        this.formDada,
                        "ticketPriceKid",
                        prices.kidPrice
                        // ? this.ScheduleTrip.TripService.price2
                        // : this.ScheduleTrip.TripService.price1
                    );
            }
        },
        async saveBooking(stay, andNew) {
            _log_('saveBooking', this.formDada)
            if (!this.formDada.tourCoId && this.formDada.tripType == 'EXCRS') {
                this.$message.warning("No tour company is set");
                // return
            }
            this.pocessing = true;

            if (this.formDada.tripType == 'EXCRS' && !this.formDada.bookedPrice) this.$set(this.formDada, 'invoiceinfo', 'block_api')
            // else
            //     this.$set(this.formDada, 'invoiceinfo', '')
            try {
                // if(!this.formDada.id&&this.formDada.tourCoId){
                //   const coInfo=await await api.fetchObject(this.classModel, this.formDada.tourCoId);
                //   _log_('getObject coInfo',coInfo)
                // }
                this.formDada = await api.updateProcessor(
                    "vue_booking/update",
                    this.formDada
                );
            } catch (error) {
                console.error(error);
                this.$message.error("Oops, " + error.message);
            }
            this.$emit("input", this.formDada);
            if (andNew) {
                this.formDada = {};
                this.pocessing = false;
                this.routeGo({params: {bookingid: "new"}});
                return;
                // await this.loadBooking("new");
                // const rPrts = this.$route.path.split("/booking/");
                // this.routeGo({ path: rPrts[0] + "/booking/new" });
            } else if (!stay) {
                this.$emit("done", this.formDada);
                // const rPrts = this.$route.path.split("/booking/");
                // this.routeGo({ path: rPrts[0] });
            }
            this.pocessing = false;
            if (this.formDada._warning) {
                this.$message.error("Oops, " + this.formDada._warning);
            }
            if (this.formDada.note__warnings) {
                Notify.create({
                    multiLine: true, position: 'top', caption: "please check it out ",
                    message: Object.values(this.formDada.note__warnings).join('.'), color: 'negative',
                })
                // this.$notify.warning("You should know , " + this.formDada.note__warnings,{});
            }
            return this.formDada;
        },
        async removeBooking(andNew) {
            this.pocessing = true;
            try {
                this.formDada = await api.removeObject("vue_booking", this.formDada);
            } catch (error) {
                _log_("error", error);
                this.$message.error("Oops, " + error.message);
                this.pocessing = false;
                return;
            }

            this.$emit("delete", this.formDada);
            this.$emit("done", this.formDada);
            this.pocessing = false;
        },
        async loadBooking(bkid) {
            this.loading = true;

            bkid = bkid ? bkid : this.$route.params.bookingid;
            if (bkid)
                if (bkid == "new") {
                    this.formDada = await api.fetchObject("vue_booking", {
                        tripid: this.$route.params.tripid,
                    }, true);
                    _log_('...this.ScheduleTrip', this.ScheduleTrip)
                    if (this.ScheduleTrip) this.$set(this.formDada, 'tripType', this.ScheduleTrip.tripType)
                } else
                    this.formDada = await api.fetchObject("vue_booking", {
                        id: bkid,
                        // with: "ScheduledTrip"s
                    });

            if (!this.formDada.mean) this.$set(this.formDada, "mean", "transfer");
            if (this.formDada.tripType == "EXCRS") {
                if (
                    this.formConfiguration.ticketNumber == "auto" &&
                    !this.formDada.ticketNumber
                )
                    this.$set(this.formDada, "ticketNum", this.uniqueKey(true));
                //  this.formDada.ticketNumber = this.uniqueKey(true);
                _log_("get $route.ticketNum", this.formDada.ticketNumber);
            }
            if (!this.formDada.bookingPayment_paymenttype)
                this.$set(this.formDada, "bookingPayment_paymenttype", "cash");
            if (!this.formDada.bookingFee_paymenttype)
                this.$set(this.formDada, "bookingFee_paymenttype", "cash");

            if (this.formConfiguration.hasTickets)
                this.$set(this.formDada, "ticketBookCheck", false);
            // _log_("ticketBookCheck user:" + this.formDada.tourCoId);
            // await this.prepareLoggedData();

            if (this.getDefaultPrices)//this is just for blocking right now TODO

                if (this.ScheduleTrip && this.ScheduleTrip.TripService) {
                    // this.$set(this.formDada,'tickePriceAdult',this.ScheduleTrip.TripService.price1)
                    if (
                        !this.formDada.tickePriceAdult ||
                        this.formDada.tickePriceAdult == 0
                    )
                        this.$set(
                            this.formDada,
                            "tickePriceAdult",
                            this.ScheduleTrip.TripService.price1
                        );
                    if (!this.formDada.ticketPriceKid || this.formDada.ticketPriceKid == 0)
                        this.$set(
                            this.formDada,
                            "ticketPriceKid",
                            this.ScheduleTrip.TripService.price2
                            // ? this.ScheduleTrip.TripService.price2
                            // : this.ScheduleTrip.TripService.price1
                        );

                    _log_("set b oo ", this.formDada, this.formDada.tickePriceAdult);
                }
            // this.$set(this.formDada, "ticketNum", "3423");
            // this.formDada.tourCoId =
            //   this.userRelCoId && !this.formDada.tourCoId
            //     ? this.userRelCoId
            //     : this.formDada.tourCoId;
            this.loading = false;
        },
        async prepareLoggedData(ctx) {
            const hasid = this.formDada.tourCoId + "";
            _log_(
                "checking user:" + this.formDada.tourCoId,
                this.formDada,
                ctx
            );
            this.loggedUser = await this.getLoggedUser(ctx);

            if (this.loggedUser) {
                if (!this.formDada.tourCoId && this.loggedUser.relTourCompany) {
                    this.$set(
                        this.formDada,
                        "tourCoId",
                        this.loggedUser.relTourCompany.id
                    );
                    if (!this.formDada.repid)
                        this.$set(this.formDada, "repid", this.loggedUser.relRep.id);
                }
                if (this.loggedUser.workingPlaces) {
                    this.userPups = {id_in: this.loggedUser.workingPlaces};

                    const arr = this.loggedUser.workingPlaces.split(",");
                    if (!this.formDada.pupAid) this.$set(this.formDada, "pupAid", arr[0]);
                    if (!this.formDada.pupZid) this.$set(this.formDada, "pupZid", arr[0]);
                }
            }
            _log_("checking user", this.formDada);
        },
    },
    mounted() {
    },
};
